import { memo } from "react";
import Box from "@mui/material/Box";
import {
    PaymentMethodTag,
    PaymentMethodCountries,
    PaymentMethodCurrencies
} from "ui/molecules/PaymentMethod";
import PaymentMethodName from "./PaymentMethodName";
import PaymentMethodProvider from "./PaymentMethodProvider";
import PaymentMethodMerchant from "./PaymentMethodMerchant";
import { usePaymentMethodContext } from "../PaymentMethodProvider";
import usePaymentMethodsContext from "../../PaymentMethodsProvider/usePaymentMethodsContext";

const PaymentMethodSummary = () => {
    const { getPaymentMethod } = usePaymentMethodContext();
    const { selectedIds, toggleSelection } = usePaymentMethodsContext();

    const paymentMethod = getPaymentMethod();
    const isPersisted = paymentMethod?.coreId !== undefined && paymentMethod?.coreId !== null;

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: '2fr 1fr 1fr 2fr 1fr 1fr',
                gap: 1,
                width: '100%',
                alignItems: 'center'
            }}
        >
            <PaymentMethodName
                {...paymentMethod}
                selected={Boolean(isPersisted && selectedIds?.has(String(paymentMethod.coreId)))}
                onSelectionChange={isPersisted && toggleSelection
                    ? checked => toggleSelection(paymentMethod.coreId, checked)
                    : undefined}
            />
            <PaymentMethodTag
                {...paymentMethod}
            />
            <PaymentMethodProvider
                {...paymentMethod}
            />
            <PaymentMethodMerchant
                {...paymentMethod}
            />
            <PaymentMethodCountries
                {...paymentMethod}
            />
            <PaymentMethodCurrencies
                {...paymentMethod}
            />
        </Box>
    );
};

export default memo(PaymentMethodSummary);
